import {IInputVoting} from 'features/election/store/types';
import {createAction, createAsyncAction} from 'typesafe-actions';
import {ISinglePlate, ISingleVoting} from './types';

export const eSingleClearData = createAction('@E_SINGLE/CLEAR_DATA')();

export const eSingleLoadPlatesAsync = createAsyncAction(
  '@E_SINGLE/LOAD_SINGLE_PLATES_REQUEST',
  '@E_SINGLE/LOAD_SINGLE_PLATES_SUCCESS',
  '@E_SINGLE/LOAD_SINGLE_PLATES_FAILURE',
  '@E_SINGLE/LOAD_SINGLE_PLATES_CANCEL'
)<string[], ISinglePlate[], string, void>();

export const eSingleRequestVotingAsync = createAsyncAction(
  '@E_SINGLE/VOTING_SINGLE_REQUEST',
  '@E_SINGLE/VOTING_SINGLE_SUCCESS',
  '@E_SINGLE/VOTING_SINGLE_FAILURE',
  '@E_SINGLE/VOTING_SINGLE_CANCEL'
)<IInputVoting[], ISingleVoting[], string, void>();



// WEBPACK FOOTER //
// ./src/features/election-single/store/actions.ts